import { render, staticRenderFns } from "./applyReminderDialog.vue?vue&type=template&id=b81bf716&scoped=true"
import script from "./applyReminderDialog.vue?vue&type=script&lang=js"
export * from "./applyReminderDialog.vue?vue&type=script&lang=js"
import style0 from "./applyReminderDialog.vue?vue&type=style&index=0&id=b81bf716&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81bf716",
  null
  
)

export default component.exports